import React from 'react';

const PasswordStrengthIndicator = ({ password }) => {
  const calculateStrength = (pwd) => {
    let score = 0;
    const feedback = [];

    if (pwd.length >= 8) score += 1;
    else feedback.push('At least 8 characters');

    if (/[a-z]/.test(pwd)) score += 1;
    else feedback.push('One lowercase letter');

    if (/[A-Z]/.test(pwd)) score += 1;
    else feedback.push('One uppercase letter');

    if (/[0-9]/.test(pwd)) score += 1;
    else feedback.push('One number');

    if (/[^A-Za-z0-9]/.test(pwd)) score += 1;
    else feedback.push('One special character');

    return { score, feedback };
  };

  const { score, feedback } = calculateStrength(password);
  const strengthLabels = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong', 'Very Strong'];
  const strengthColors = ['bg-red-500', 'bg-orange-500', 'bg-yellow-500', 'bg-blue-500', 'bg-green-500', 'bg-green-600'];

  return (
    <div className="mt-2">
      <div className="flex space-x-1 mb-1">
        {[1, 2, 3, 4, 5].map((index) => (
          <div
            key={index}
            className={`h-1 flex-1 rounded-full ${
              index <= score ? strengthColors[score] : 'bg-gray-200'
            }`}
          />
        ))}
      </div>
      <div className="text-xs text-gray-600">
        <span className="font-medium">Strength: {strengthLabels[score]}</span>
        {feedback.length > 0 && (
          <span className="ml-2">- Add: {feedback.slice(0, 2).join(', ')}</span>
        )}
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;